import Vue from "vue";
import Component from "vue-class-component";
import axios from "axios";

import { store, isDev, isHml } from "@/store";
import messagesService from "@/services/messagesService";
import menuData from "./assets/menu.json";
import { PortalError } from "./types/portal-error";
import { SelectValue } from "./types/select-value";
import {
  defaultCPFFormatter,
  defaultInativoFormatter,
} from "@/types/table-field";

@Component
export class UtilsTS extends Vue {

  vMoneyOptions = {
    decimal: ",",
    thousands: ".",
    prefix: "R$ ",
    suffix: "",
    precision: 2,
    masked: false,
  };
  vMoney4CasasOptions = {
    ...this.vMoneyOptions,
    precision: 4,
  };
  cpfMaskedInputProps = {
    type: "text",
    inputmode: "numeric",
    maxlength: "14",
    autocomplete: "off",
  };
  telefoneMaskedInputProps = {
    type: "text",
    inputmode: "numeric",
    maxlength: "15",
    autocomplete: "off",
  };
  cepMaskedInputProps = {
    type: "text",
    inputmode: "numeric",
    maxlength: "9",
    autocomplete: "off",
  };
  dateMaskedInputProps = {
    inputmode: "numeric",
    autocomplete: "off",
    placeholder: "dd/mm/aaaa",
  };

  vueTelOptions = {
    defaultCountry: "BR",
    disabledFetchingCountry: true,
    invalidMsg: "Telefone inválido",
    enabledCountryCode: false,
    dropdownOptions: {
      disabledDialCode: true,
    },
  };

  digitsOnly(value: string, maxLen?: number): string {
    const digits = (value || "").replace(/\D+/g, "");
    return typeof maxLen === "number" ? digits.slice(0, maxLen) : digits;
  }

  formatCpfMask(value: string): string {
    const d = this.digitsOnly(value, 11);
    if (d.length <= 3) return d;
    if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
    if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
  }

  formatTelefoneMask(value: string): string {
    const d = this.digitsOnly(value, 11);
    if (d.length <= 2) return d;
    if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
    if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
    return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  }

  formatCepMask(value: string): string {
    const d = this.digitsOnly(value, 8);
    if (d.length <= 5) return d;
    return `${d.slice(0, 5)}-${d.slice(5)}`;
  }

  get valor10MBemBytes(): number {
    return 10485760;
  }
  removerAcentuacao(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  formatMoeda(valor: number): string {
    if (valor) {
      const valorString = valor.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
      return valorString;
    }
    return "";
  }
  formatDataDB(data: string | Date): string {
    return data ? new Date(data).toISOString().slice(0, 10) : "";
  }
  formatData(data: string | Date): string {
    return data ? new Date(data).toLocaleDateString("pt-br") : "";
  }

  formatDataHora(data: string | Date): string {
    return data ? new Date(data).toLocaleString("pt-br") : "";
  }

  getCurrentDate(): string {
    return new Date().toLocaleDateString("pt-br");
  }
  padZeros(number, size): string {
    let s = String(number);
    while (s.length < (size || 2)) {
      s = "0" + s;
    }
    return s;
  }
  formatDataComHora(data): string {
    const dataObj = new Date(data);
    const dia = dataObj.getDate().toString().padStart(2, "0");
    const mes = (dataObj.getMonth() + 1).toString().padStart(2, "0");
    const ano = dataObj.getFullYear();
    const horas = dataObj.getHours().toString().padStart(2, "0");
    const minutos = dataObj.getMinutes().toString().padStart(2, "0");
    const segundos = dataObj.getSeconds().toString().padStart(2, "0");
    const milisegundos = dataObj.getMilliseconds().toString().padStart(3, "0");
    const dataFormatada = `${dia}/${mes}/${ano} às ${horas}:${minutos}:${segundos}.${milisegundos}`;

    return data ? dataFormatada : "";
  }
  isNumeric(n): boolean {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
  truncateText(text, maxSize = 40): string {
    const txt = text.trim();
    return txt.length < maxSize ? txt : txt.substring(0, maxSize) + "...";
  }
  sortByCode(a, b): number {
    if (a.code < b.code) return -1;
    if (a.code > b.code) return 1;
    return 0;
  }
  formatedUGLabels(optionsUG) {
    return optionsUG
      .filter((f) => f.Nome && f.Codigo)
      .map((m) => {
        m.Nome = this.capitalize(m.Nome);
        return m;
      });
  }
  capitalize(text): string {
    if (!text || !text.length) return "";
    const short = ["da", "do", "das", "dos", "a", "e", "de"];
    if (!text) return "";
    return text
      .split(" ")
      .map((word) => {
        if (short.includes(word.toLowerCase())) {
          return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.toLowerCase().slice(1);
      })
      .join(" ");
  }
  getAbsoluteHeight(el): number {
    try {
      el = document.querySelector(el);
      const styles = window.getComputedStyle(el);
      const margin =
        parseFloat(styles["marginTop"]) + parseFloat(styles["marginBottom"]);
      return Math.ceil(el.offsetHeight + margin) || 0;
    } catch (e) {
      return 0;
    }
  }
  async updateUserMenu(permissions: string[]): Promise<void> {
    if (store.primeiroAcesso == "N") {
      await this.clearUserMenu();
      permissions.forEach((link) => {
        const node = this.getNodeByLink(link, menuData, null);

        if (node) {
          let aux = node.parent;
          while (aux) {
            aux.hidden = false;
            aux = aux.parent;
          }
          node.hidden = false;
        }
      });
      store.userMenu = menuData;
    } else {
      store.userMenu = [];
    }
  }
  clearUserMenu(): void {
    menuData.forEach((item) => {
      if (
        item.hidden === false &&
        item.href !== "/perfil" &&
        item.href !== "/sair"
      ) {
        item.hidden = true;
      }
      if (item.child) {
        item.child.forEach((chi) => {
          if (chi.hidden === false) {
            chi.hidden = true;
          }
        });
      }
    });
  }
  getNodeByLink(link, items, parent) {
    for (const node of items) {
      node.parent = parent;
      if (node.href === link) {
        return node;
      }
      if (node.child) {
        const child = this.getNodeByLink(link, node.child, node);
        if (child) {
          return child;
        }
      }
    }
    return null;
  }
  async loadCPAlert() {
    if (store.primeiroAcesso == "N") {
      const response = await messagesService.mostrarAlertaCP();
      if (response && response.status == 200) {
        return response.data;
      } else {
        return null;
      }
    }
  }
  download(filename, content) {
    const element = document.createElement("a");
    element.setAttribute("href", URL.createObjectURL(content));
    element.setAttribute("download", filename);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  downloadFromUrl(filename, url) {
    const element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("download", filename);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }
  validarCPF(_cpf): boolean {
    const cpf = _cpf.replace(/\D/g, "");
    if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    let result = true;
    [9, 10].forEach(function (j) {
      let soma = 0,
        r;
      cpf
        .split(/(?=)/)
        .splice(0, j)
        .forEach(function (e, i) {
          soma += parseInt(e) * (j + 2 - (i + 1));
        });
      r = soma % 11;
      r = r < 2 ? 0 : 11 - r;
      if (r != cpf.substring(j, j + 1)) result = false;
    });
    return result;
  }
  sortArrayObjectByKey(array, key) {
    return array.sort(function (a, b) {
      const x = a[key];
      const y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

  /**
   * Loga e imprime um erro (exception).
   *
   * @param err Instância Js Error ou classe derivada
   * @param perma true se não quiser timeout
   */
  tratarError(err: Error | unknown, perma = false): void {
    console.error(err);
    const timeout = perma ? false : 4000;
    if (err instanceof PortalError) {
      err.messages.map((msg) => this.$toast.error(msg, { timeout }));
      return;
    }
    if (axios.isAxiosError(err)) {
      const data = err.response?.data as
      | { message?: string; msg?: string; errors?: string[]; erros?: string[] }
      | undefined;
      if (
        data?.errors &&
        Array.isArray(data.errors) &&
        data.errors.length > 0
      ) {
        data.errors.map((msg) => this.$toast.error(msg, { timeout }));
        return;
      }
      
      if (
        data?.erros &&
        Array.isArray(data.erros) &&
        data.erros.length > 0
      ) {
        data.erros.map((msg) => this.$toast.error(msg, { timeout }));
        return;
      }
      if (
        data?.message &&
        Array.isArray(data.message) &&
        data.message.length > 0
      ) {
        data.message.map((msg) => this.$toast.error(msg, { timeout }));
        return;
      }
      this.$toast.error(
        data?.message ?? data?.msg ?? "Falha de comunicação com o servidor",
        { timeout },
      );
      return;
    }
    if (err instanceof Error) {
      this.$toast.error(err.message ?? err, { timeout });
      return;
    }
    this.$toast.error("Erro desconhecido (" + err + ")", { timeout });
  }

  base64ToPdf(pdfData: string): Blob {
    return this.base64ToBlob(pdfData, "application/pdf");
  }

  base64ToBlob(data: string, mimeType: string): Blob {
    // conversão powered by GePeTo
    // Convert Base64 to ArrayBuffer
    const binaryString = window.atob(data);
    const byteArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i);
    }

    // Create Blob from ArrayBuffer
    return new Blob([byteArray], { type: mimeType });
    // FIM de conversão powered by GePeTo
  }

  /**
   * Criado para facilitar uso em selects pelo sistema.
   * Uso inicial em relatórios de gestão/pca.
   * @since 202309
   */
  getListaAnos2017ateAnoAnterior(): string[] {
    const anoAtual = new Date().getFullYear();
    const listaAnos: string[] = [];
    for (let i = 2017; i < anoAtual; i++) {
      listaAnos.push(String(i));
    }
    return listaAnos;
  }

  getListaAnos2017ateAnoAtual(): string[] {
    const anoAtual = new Date().getFullYear();
    const listaAnos: string[] = [];
    for (let i = 2017; i <= anoAtual; i++) {
      listaAnos.push(String(i));
    }
    return listaAnos;
  }
  getListaAnos2023ateAnoAtual(): string[] {
    const anoAtual = new Date().getFullYear();
    const listaAnos: string[] = [];
    for (let i = 2023; i <= anoAtual; i++) {
      listaAnos.push(String(i));
    }
    return listaAnos;
  }

  getListaMeses(): SelectValue[] {
    const anoTodo: SelectValue[] = [];
    anoTodo.push({ text: "01 - Janeiro", value: "1" });
    anoTodo.push({ text: "02 - Fevereiro", value: "2" });
    anoTodo.push({ text: "03 - Março", value: "3" });
    anoTodo.push({ text: "04 - Abil", value: "4" });
    anoTodo.push({ text: "05 - Maio", value: "5" });
    anoTodo.push({ text: "06 - Junho", value: "6" });
    anoTodo.push({ text: "07 - Julho", value: "7" });
    anoTodo.push({ text: "08 - Agosto", value: "8" });
    anoTodo.push({ text: "09 - Setembro", value: "9" });
    anoTodo.push({ text: "10 - Outubro", value: "10" });
    anoTodo.push({ text: "11 - Novembro", value: "11" });
    anoTodo.push({ text: "12 - Dezembro", value: "12" });
    return anoTodo;
  }

  simOuNao(valor?: boolean): string {
    return valor === true ? "Sim" : "Não";
  }

  formatarSituacaoAviso(situacao: number): string {
    switch (situacao) {
      case 0:
        return "Inativo";
      case 1:
        return "Ativo";
      case 2:
        return "Pendente Liberação";
      default:
        return situacao.toString();
    }
  }

  getBaseColor(): string {
    return isDev() ? '#555555' : isHml() ? '#0069bf' : '#007d47'
  }

  formatarCPF(cpf: string): string {
    return defaultCPFFormatter(cpf);
  }

  formatarInativo(val: string): string {
    return defaultInativoFormatter(val);
  }

  formatarCEP(cep: string): string {
    if (cep?.length > 0) {
      if (cep.length < 8) {
        cep = cep.concat("0");
        return this.formatarCEP(cep);
      }
      return cep.slice(0, 5) + "-" + cep.slice(5);
    } else return "";
  }

  formatarSexo(valor: string): string {
    switch (valor) {
      case "1":
        return "Masculino";
      case "2":
        return "Feminino";
      default:
        return "";
    }
  }

  removeZeroEsquerda(numero: string): string {
    if (numero[0] == "0") return this.removeZeroEsquerda(numero.slice(1));
    return numero;
  }

  /**
   * Define o placeholder do componente vue-tel-input.
   * @param placeholder O texto do placeholder.
   */
  setVueTelPlaceholder(placeholder = "(99) 99999-9999"): void {
    const input: any = document.querySelector(".vti__input");
    if (input) input.placeholder = placeholder;
  }

  /**
   * Retorna apenas os números de uma string.
   * Útil para campos como CPF, CNPJ, telefone, etc.
   *
   * @param texto Texto a ser processado
   * @returns Texto contendo apenas números
   * @since 202510
   */
  apenasNumeros(texto: string): string | null {
    const apenasNumero = texto.replace(/\D/g, "");
    return apenasNumero.length == 0
      ? null
      : apenasNumero;
  }

  copiarTexto(texto: string): void {
    navigator.clipboard.writeText(texto)
      .then(() => {
        this.$toast.success("Texto copiado para a área de transferência", { timeout: 1000 });
      })
      .catch((err) => {
        this.$toast.error("Falha ao copiar texto: " + err, { timeout: 2000 });
      });
  }
}
